import { render, staticRenderFns } from "./DedicatedVLANTab.vue?vue&type=template&id=5fa9f7b5&scoped=true&"
import script from "./DedicatedVLANTab.vue?vue&type=script&lang=js&"
export * from "./DedicatedVLANTab.vue?vue&type=script&lang=js&"
import style0 from "./DedicatedVLANTab.vue?vue&type=style&index=0&id=5fa9f7b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9f7b5",
  null
  
)

export default component.exports